import { render } from "./CobraDocuments.vue?vue&type=template&id=f4eceaa6&scoped=true&ts=true"
import script from "./CobraDocuments.vue?vue&type=script&lang=ts"
export * from "./CobraDocuments.vue?vue&type=script&lang=ts"

import "./CobraDocuments.vue?vue&type=style&index=0&id=f4eceaa6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4eceaa6"]])

export default __exports__